

// 3) CornerSticker.tsx (same API, we’ll just use tighter equal offsets in the hero)
// Path: packages/components/src/homepage/hero/CornerSticker.tsx

import React from 'react';
import clsx from 'clsx';

export type CornerStickerProps = {
  text?: string;
  position?: 'top-left' | 'top-right';
  angleDeg?: number;
  offsetX?: number;
  offsetY?: number;
  className?: string;
};

export const CornerSticker: React.FC<CornerStickerProps> = ({
  text = 'Ethical by design • 33% to non‑profits you choose',
  position = 'top-left',
  angleDeg = -8,
  offsetX = 0,
  offsetY = 0,
  className,
}) => {
  const baseStyle: React.CSSProperties =
    position === 'top-left'
      ? { top: 0, left: 0, transformOrigin: 'top left' }
      : { top: 0, right: 0, transformOrigin: 'top right' };

  return (
    <div
      className={clsx('absolute z-20 pointer-events-none select-none', className)}
      style={{
        ...baseStyle,
        transform: `translate(${offsetX}px, ${offsetY}px) rotate(${angleDeg}deg)`,
      }}
    >
      <div className="inline-block bg-amber-100 text-amber-900 border-2 border-black rounded-md px-3 py-1 text-xs font-extrabold shadow-[3px_3px_0_rgba(0,0,0,0.9)]">
        {text}
      </div>
    </div>
  );
};

export default CornerSticker;